<template>
  <div :class="isLeft ? 'floL' : 'floR'">
    <p
      class="fntH6 fntL bold marTML marBM" style="color:#2c2c2c; width:49%;"
      :style="isLeft ? { width: '49%' } : null"
    >{{ getFullTextByType(participant) }}</p>

    <!-- 참여 여부 -->
    <div
      :class="isLeft ? 'pf23-inFo-L' : 'pf23-inFo-R'"
      class="padBM"
    >
      <p
        :class="{ moOnly: !isLeft }"
        class="fntP"
      >참여여부 <span class="ico-must-astar"></span></p>
      
      <div class="amway-theme" style="width:55%;">
        <div class="action pf23-radioBtn radio-wrapper pf23-inFo-radio">
          <label class="amw-radio-wrap radio-label focus">
            <input
              type="radio"
              :name="`attendance-radio-${seq}`"
              class="amw-global-radio"
              value="Y"
              @change="selectAttendance"
              :checked="participant.attendance_yn === 'Y'"
              :disabled="!infoAvailable"
            />
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text">참여</span>
          </label>

          <label class="amw-radio-wrap radio-label focus">
            <input
              type="radio"
              :name="`attendance-radio-${seq}`"
              class="amw-global-radio"
              value="N"
              @change="selectAttendance"
              :checked="participant.attendance_yn === 'N'"
              :disabled="!infoAvailable"
            />
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text">불참</span>
          </label>
        </div>
      </div>
    </div>

    <!-- 이름 -->
    <div
      :class="isLeft ? 'pf23-inFo-L' : 'pf23-inFo-R'"
      class="padBSM padTSM pf23-inFo-common pf23-lineBtm"
    >
      <label
        :for="`NCAcmi_name${seq}`"
        class="fntP"
        :class="{ moOnly: !isLeft }"
      >이름 <span class="ico-must-astar"></span></label>
      <input
        type="text"
        :id="`NCAcmi_name${seq}`"
        :name="`NCAcmi_name${seq}`"
        :value="participant.name"
        @input="inputName(seq, $event.target.value)"
        :disabled="disabledByType || disabledByAttendance || !infoAvailable"
        size="50"
        maxlength="50"
      />
    </div>

    <!-- ABO 번호 -->
    <div
      :class="isLeft ? 'pf23-inFo-L pf23-inFo-common' : 'pf23-inFo-blank01'"
      class="padBSM padTSM pf23-lineBtm"
    >
      <template v-if="isLeft">
        <label
          :for="`NCAcmi_abo${seq}`"
          class="fntP"
        >ABO번호</label>
        <input
          type="text"
          :id="`NCAcmi_abo${seq}`"
          :name="`NCAcmi_abo${seq}`"
          :value="participant.abo_uid"
          disabled
        >
      </template>      
    </div>

    <!-- ADD : 휴대폰번호 -->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap">
        <label
          :for="`Q110-${seq}`"
          :class="{ moOnly: !isLeft }"
          class="fntP"
        >휴대폰번호 <span class="ico-must-astar"></span>
        </label>
        010 -
        <input
          type="text"
          class="NCAcmi_num "
          :id="`Q110-${seq}`"
          :class="(participant.questions['Q110'].hasError && participant.questions['Q110'].raw_data)? 'check-red' : ''"
          :value="participant.questions['Q110'].raw_data"
          @input="inputNumberAnswer(seq, 'Q110', $event.target, 8)"
          size="50"
          maxlength="8"
          :disabled="disabledByAttendance || !infoAvailable"
          placeholder="- 없이 입력"
        />
      </div>
      <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;"><template v-if="(participant.questions['Q110'].hasError && participant.questions['Q110'].raw_data)">🚫 010 뒤의 숫자 8자리를 입력해주세요.</template></p>
    </div>

    <!-- ADD : 내국인여부 -->
    <div
      :class="isLeft ? 'pf23-inFo-L' : 'pf23-inFo-R'"
      class="padBSM padTSM pf23-lineBtm"
    >
      <label
        :for="`Q111-${seq}`"
        :class="{ moOnly: !isLeft }"
        class="fntP"
      >내국인여부 <span class="ico-must-astar"></span>
      </label>
      <div class="amway-theme" style="width:55%;">
        <div class="action pf23-radioBtn radio-wrapper pf23-inFo-radio">
          <label class="amw-radio-wrap radio-label focus">
            <input
              type="radio"
              :id="`Q111-${seq}`"
              :name="`domestic-radio-${seq}`"
              class="amw-global-radio"
              value="DOMESTIC"
              @change="inputRadioDomesticAnswer(`${seq}`, 'Q111', 'DOMESTIC'); inputSelectAnswer(`${seq}`, 'Q115', null, '대한민국');"
              :checked="participant.questions['Q111'].raw_data === 'DOMESTIC'"
              :disabled="disabledByAttendance || !infoAvailable"
            />
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text">내국인</span>
          </label>

          <label class="amw-radio-wrap radio-label focus">
            <input
              type="radio"
              :id="`Q111-${seq}`"
              :name="`domestic-radio-${seq}`"
              class="amw-global-radio"
              value="FOREIGNER"
              @change="inputRadioDomesticAnswer(`${seq}`, 'Q111', 'FOREIGNER'); inputSelectAnswer(`${seq}`, 'Q115', null, '');"
              :checked="participant.questions['Q111'].raw_data === 'FOREIGNER'"
              :disabled="disabledByAttendance || !infoAvailable"
            />
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text">외국인</span>
          </label>
        </div>
      </div>
    </div>

    <!-- 주민등록번호 -->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap-normal">
        <label
          :for="`Q112_1-${seq}`"
          class="fntP"
          style="width:45%;"
        >{{ participant.questions['Q111'].raw_data == 'FOREIGNER' ? '외국인등록번호' : '주민등록번호' }}<span class="ico-must-astar"></span>
        </label>
        <em class="txtR" style="width:55%;"
        ><input
          type="text"
          :id="`Q112_1-${seq}`"
          :name="`NCAcmi_personal${seq}-1`" 
          class="NCAcmi_num"
          :class="(participant.questions['Q112_1'].hasError && participant.questions['Q112_1'].raw_data) ? 'check-red' : ''"
          style="width:45%; "
          :value="participant.questions['Q112_1'].raw_data"
          @input="inputJuminFirstNumber(seq, 'Q112_1', $event.target)"
          maxlength="6"
          :disabled="disabledByAttendance || !infoAvailable || participant.questions['Q111'].hasError"
        /><span class="disIb txtC" style="width:10%;">-</span
        ><input
          type="text"
          :id="`Q112_2-${seq}`"
          :name="`NCAcmi_personal${seq}-2`"
          class="NCAcmi_num"
          :class="(participant.questions['Q112_2'].hasError && participant.questions['Q112_2'].raw_data) ? 'check-red' : ''"
          style="width:45%; "
          :value="participant.questions['Q112_2'].raw_data"
          @input="inputJuminLastNumber(seq, 'Q112_2', $event.target, 'Q114');"
          maxlength="7"
          :disabled="disabledByAttendance || !infoAvailable || participant.questions['Q111'].hasError"
        /></em>
      </div>
      <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;height: 21px;">
        <template v-if="(participant.questions['Q112_1'].hasError || participant.questions['Q112_2'].hasError) && (participant.questions['Q112_1'].raw_data || participant.questions['Q112_2'].raw_data)">
        🚫 {{juminHasError}}
        </template>
      </p>
    </div>

    <!-- ADD : 성별 -->
    <div
      :class="isLeft ? 'pf23-inFo-L' : 'pf23-inFo-R'"
      class="padBSM padTSM pf23-lineBtm"
    >
      <label
        :for="`Q114-${seq}`"
        :class="{ moOnly: !isLeft }"
        class="fntP"
      >성별 <span class="ico-must-astar"></span>
      </label>
      <div class="amway-theme" style="width:55%;">
        <div class="action pf23-radioBtn radio-wrapper pf23-inFo-radio">
          <label class="amw-radio-wrap radio-label focus">
            <input
              type="radio"
              :id="`Q114-${seq}`"
              :name="`gender-radio-${seq}`"
              class="amw-global-radio"
              value="FEMALE"
              :checked="participant.questions['Q114'].raw_data === 'FEMALE'"
              :disabled="true"
            />
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text">여성</span>
          </label>

          <label class="amw-radio-wrap radio-label focus">
            <input
              type="radio"
              :id="`Q114-${seq}`"
              :name="`gender-radio-${seq}`"
              class="amw-global-radio"
              value="MALE"
              :checked="participant.questions['Q114'].raw_data === 'MALE'"
              :disabled="true"
            />
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text">남성</span>
          </label>
        </div>
      </div>
    </div>
    <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;height: 21px;">* 주민/외국인 등록번호에 따라 자동선택됩니다.</p>

    <!-- ADD : 영문 성 -->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap-normal">
        <label
          :for="`Q113_1-${seq}`"
          :class="{ moOnly: !isLeft }"
          class="fntP"
        >여권 영문 성 <span class="ico-must-astar"></span>
        </label>
        <input
          type="text"
          :id="`Q113_1-${seq}`"
          :name="`NCAcmi_engname01${seq}-1`" 
          class="NCAcmi_num"
          :class="(participant.questions['Q113_1'].hasError && participant.questions['Q113_1'].raw_data) ? 'check-red' : ''"
          :value="participant.questions['Q113_1'].raw_data"
          @input="inputEngAnswer(seq, 'Q113_1', $event.target)"
          size="50"
          maxlength="30"
          :disabled="disabledByAttendance || !infoAvailable"
          placeholder="여권 영문 성"
        />
      </div>
      <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;"><template v-if="(participant.questions['Q113_1'].hasError && participant.questions['Q113_1'].raw_data)">🚫 2자 이상 영문으로 입력해주세요.</template></p>
    </div>
    
    
    <!-- ADD : 영문 이름 -->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap-normal">
        <label
          :for="`Q113_2-${seq}`"
          :class="{ moOnly: !isLeft }"
          class="fntP"
        >여권 영문 이름 <span class="ico-must-astar"></span>
        </label>
        <input
          type="text"
          :id="`Q113_2-${seq}`"
          class="NCAcmi_num"
          :class="(participant.questions['Q113_2'].hasError && participant.questions['Q113_2'].raw_data) ? 'check-red' : ''"
          :value="participant.questions['Q113_2'].raw_data"
          @input="inputEngAnswer(seq, 'Q113_2', $event.target)"
          size="50"
          maxlength="30"
          :disabled="disabledByAttendance || !infoAvailable"
          placeholder="여권 영문 이름"
        />
      </div>
      <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;"><template v-if="(participant.questions['Q113_2'].hasError && participant.questions['Q113_2'].raw_data)">🚫 2자 이상 영문으로 입력해주세요.</template></p>
    </div>

    <!-- ADD : 국가 -->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap-normal">
        <label
          :for="`Q115-${seq}`"
          :class="{ moOnly: !isLeft }"
          class="fntP"
        >국가 <span class="ico-must-astar"></span>
        </label>
        <div class="pf23-inFo-select pf23-country" >
          <select class="form-control" :value="participant.questions['Q115'].raw_data" 
            :id="`Q115-${seq}`"
            @change="inputSelectAnswer(seq, 'Q115', $event.target)"
            :disabled="disabledByAttendance || !infoAvailable || participant.questions['Q111'].raw_data === 'DOMESTIC' "
            :class="ishint && participant.questions['Q115'].hasError ? 'check-red' : ''"
          >
            <option value="">국가선택</option>
            <template v-for="(country, index) in counties" >
              <option :value="country.COUNTRY_KOR_NM" :key="index" :checked="participant.questions['Q115'].raw_data == country.COUNTRY_KOR_NM">{{country.COUNTRY_ISO_WORD3}} - {{ country.COUNTRY_KOR_NM}}</option>
            </template> 
          </select>
        </div>
      </div>
      <p v-if="participant.questions['Q111'].raw_data === 'DOMESTIC'" class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">* 내국인은 대한민국 자동 선택됩니다.</p>
      <p v-if="participant.questions['Q111'].raw_data !== 'DOMESTIC'" class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;"><template v-if="ishint && participant.questions['Q115'].hasError">🚫 국가를 선택해 주세요.</template></p>
    </div>
    
    <!-- ADD : 여권번호 -->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap-normal">
        <label
          :for="`Q116-${seq}`"
          :class="{ moOnly: !isLeft }"
          class="fntP"
        >여권번호 <span class="ico-must-astar"></span>
        </label>
        <input
          type="text"
          :id="`Q116-${seq}`"
          :name="`NCAcmi_passportnumber${seq}-1`" 
          class="NCAcmi_num"
          :class="(participant.questions['Q116'].hasError && participant.questions['Q116'].raw_data) ? 'check-red' : ''"
          :value="participant.questions['Q116'].raw_data"
          @input="inputPassportAnswer(seq, 'Q116', $event.target)"
          size="50"
          maxlength="20"
          :disabled="disabledByAttendance || !infoAvailable"
        />
      </div>
      <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;height: 21px;">
        <template v-if="(participant.questions['Q116'].hasError && participant.questions['Q116'].raw_data)">🚫 여권 번호를 입력해 주시기 바랍니다.</template>
      </p>
    </div>

    <!-- ADD : 여권발급일 -->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap-normal">
        <label
          :for="`Q117-${seq}`"
          :class="{ moOnly: !isLeft }"
          class="fntP"
        >여권발급일 <span class="ico-must-astar"></span>
        </label>
        <input
          type="date"
          :id="`Q117-${seq}`"
          :name="`NCAcmi_passportfrom${seq}`" 
          class="NCAcmi_num"
          :class="ishint && participant.questions['Q117'].hasError ? 'check-red' : ''"
          :value="participant.questions['Q117'].raw_data"
          @change="inputPassportDateAnswer(seq, 'Q117', $event.target)"
          size="50"
          maxlength="50"
          :disabled="disabledByAttendance || !infoAvailable"
          :max="today"
        />
      </div>
      <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">
          <template v-if="ishint && participant.questions['Q117'].hasError">🚫 {{participant.questions['Q117'].remarks ? participant.questions['Q117'].remarks : "여권발급일을 선택해주세요."}}</template>
      </p>
    </div>
    
    <!-- ADD : 여권만료일 -->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap-normal">
        <label
          :for="`Q118-${seq}`"
          :class="{ moOnly: !isLeft }"
          class="fntP"
        >여권만료일 <span class="ico-must-astar"></span>
        </label>
        <input
          type="date"
          :id="`Q118-${seq}`"
          :name="`NCAcmi_passportend${seq}`" 
          class="NCAcmi_num"
          :class="ishint && participant.questions['Q118'].hasError ? 'check-red' : ''"
          :value="participant.questions['Q118'].raw_data"
          @change="inputPassportDateAnswer(seq, 'Q118', $event.target); navtiveAlert('여권 만료일은 출국일로부터 6개월 이상이어야 합니다.\n잔여 유효기간이 6개월 미만인 경우 여권을 재발급 받은 후 담당 여행사 (02-2022-6520)로 연락주시기 바랍니다.');"
          size="50"
          maxlength="50"
          :disabled="disabledByAttendance || !infoAvailable"
          :min="today"
        />
      </div>
      <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">
        <template v-if="ishint && participant.questions['Q118'].hasError">🚫 {{participant.questions['Q118'].remarks ? participant.questions['Q118'].remarks : "여권만료일을 선택해주세요."}}</template>
      </p>
    </div>

    <!-- 여권 사본 -->
    <SurveyAttachment
      class="padBSM padTSM pf23-lineBtm"
      :class="{ NCAcmi_last: participant.type === 'S' || (participant.type === 'P' && hideDocument) }"
      :participant="participant"
      :sq-code="'Q100'"
      :disabled="disabledByAttendance || !infoAvailable"
      :is-left="isLeft"
      :id="`Q100-${seq}`"
    /> 

    <!-- 안전확인 동의서 -->
    <SurveyAttachmentCommon
      v-if="memberAttendants"
      class="padBSM padTSM pf23-lineBtm"
      :class="{ NCAcmi_blankR: hideDocument }"
      :participant="participant"
      :sq-code="'Q101'"
      :hide-btn="hideDocument"
      :disabled="disabledByAttendance || !infoAvailable"
      :is-left="isLeft"
      :height="hideDocument ? `121px` : null"
      :id="`Q101-${seq}`"
      :display-right="hideDocument"      
    /> 

    <!-- 초상권 확인 동의서 -->
    <SurveyAttachmentCommon
      v-if="memberAttendants"
      class="padBSM padTSM pf23-lineBtm"
      :class="{ NCAcmi_blankR: hideDocument }"
      :participant="participant"
      :sq-code="'Q102'"
      :hide-btn="hideDocument"
      :disabled="disabledByAttendance || !infoAvailable"
      :is-left="isLeft"
      :height="hideDocument ? `121px` : null"
      :id="`Q102-${seq}`"
      :display-right="hideDocument"      
    /> 

    <!-- 배우자 참가 신청서  -->
    <SurveyAttachmentCommon
      v-if="existSpouse"
      class="padBSM padTSM pf23-lineBtm"
      :class="{ NCAcmi_blankR: hideDocument }"
      :participant="participant"
      :sq-code="'Q103'"
      :hide-btn="!hideDocument"
      :disabled="disabledByAttendance || !infoAvailable"
      :is-left="isLeft"
      :height="hideDocument ? null : `121px`"
      :display-right="isLeft"
      :id="`Q103-${seq}`"
    />

    <!-- 가족관계 증명서  -->
    <SurveyAttachmentCommon
      v-if="existSpouse"
      :class="{ NCAcmi_blankR: hideDocument }"
      class="padBSM padTSM pf23-lineBtm"
      :sq-code="'Q104'"
      :disabled="disabledByAttendance || !infoAvailable"
      :is-left="isLeft"
      :hide-btn="!hideDocument"
      :height="hideDocument ? null : `198.19px`"
      :display-right="isLeft"
      :id="`Q104-${seq}`"
    >
      <template v-if="hideDocument && isLeft" #inner>
        <span
          v-html="questions['Q104'].alert_text"
          class="fntE pcOnly disBl"
          style="color:#d91734; padding-left: 0.6em;"
        ></span>
      </template>
      <template #outer>
        <p
          v-if="!hideDocument && isLeft"
          v-html="questions['Q104'].alert_text"
          class="marTS fntE"
          style="color:#d91734; padding-left: 0.6em;"
        ></p>
        <p
          v-if="!hideDocument && !isLeft"
          v-html="questions['Q104'].alert_text"
          class="marTS moOnly fntE"
          style="color:#d91734; padding-left: 0.6em;"
        ></p>
      </template>
    </SurveyAttachmentCommon>
  
    <!-- 안전 확인 -->
    <SurveyParticipantFloatLeftOnly
      v-if="isLeft"
      :participant="participant"
      :disabled="(!participant.attendance_yn || participant.attendance_yn === 'N') || !infoAvailable"
      :seq="seq"      
      :sqCode="`Q119`"
    />

    <!-- 알러지 -->
    <SurveyParticipantFloatLeftOnly
      v-if="isLeft"
      :participant="participant"
      :disabled="(!participant.attendance_yn || participant.attendance_yn === 'N') || !infoAvailable"
      :seq="seq"      
      :sqCode="`Q120`"
    />

    <!-- ETA 비자 -->
    <SurveyParticipantFloatLeftOnly
      v-if="isLeft"
      :participant="participant"
      :disabled="(!participant.attendance_yn || participant.attendance_yn === 'N') || !infoAvailable"
      :seq="seq"      
      :sqCode="`Q121`"
    />




    <!-- 안전확인 - mo 공동사업자 1, 모바일인 경우만 노출된다. PC 인 경우는 표시되지 않음-->
    <div class="padTSM moOnly pf23-lineBtm" v-if="false">
      <p class="fntP">안전 확인<span class="ico-must-astar"></span></p>
      <p class="fntP padTSM ">‘안전확인동의서’ 에 ‘해당사항 있음’으로 체크한 항목이 있습니까? (임산부, 장애, 지병 및 기타 질병)</p>
    
      <div class="pf23-inFo-safe-L marTSM">
        <div class="amway-theme" style="width:55%;">
          <div class="action pf23-radioBtn radio-wrapper pf23-inFo-radio">
            <label class="amw-radio-wrap radio-label focus">
              <input type="radio" name="radio01-4" class="amw-global-radio" value="Y" 
                @change="inputRadioAnswer(`${seq}`, 'Q119', 'Y')" 
                :checked="participant.questions['Q119'].raw_data === 'Y'"
                :disabled="(!participant.attendance_yn || participant.attendance_yn === 'N') || !infoAvailable">
              <span class="amw-radio-overlay"></span>
              <span class="amw-label-radio-text">예</span>
            </label>
            <label class="amw-radio-wrap radio-label focus" style="margin-right:1.5em;">
              <input type="radio" name="radio01-4" class="amw-global-radio" value="N" 
                @change="inputRadioAnswer(`${seq}`, 'Q119', 'N')" 
                :checked="participant.questions['Q119'].raw_data === 'N'"
                :disabled="(!participant.attendance_yn || participant.attendance_yn === 'N') || !infoAvailable">
              <span class="amw-radio-overlay"></span>
              <span class="amw-label-radio-text">아니오</span>
            </label>
          </div>
        </div>
      </div>

      <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">* 해당 사항이 있는 경우 반드시 상세 내용을 동의서 상에
        작성하여 주시기 바랍니다.</p>
    </div>
  </div>
</template>

<script>
import SurveyAttachment from './SurveyAttachment.vue'
import SurveyAttachmentCommon from './SurveyAttachmentCommon.vue'
import SurveyParticipantFloatLeftOnly from './SurveyParticipantFloatLeftOnly.vue'
import { mapGetters, mapState } from 'vuex'
import { CommonMethodMixin } from '../mixins'
import {
  SURVEY_SYDNEY,
  COMMON_QUESTIONS,
  SET_ATTENDANCE,
  ATTENDING_LIST,
  INFO_AVAILABLE,
  SPOUSE_ATTENDANTS,
  MEMBER_ATTENDANTS,
  NEED_FAMILY_RELATION_DOCUMENT,
  NEED_FAMILY_DOCUMENT,
  SET_FAMILY_ATTENDANCE_YN,
  CLEAR_RESPONSE_DATA,
  GET_CODE_COUNTRY,
  GET_CODE_TODAY,
  GET_CODE_PASSPORT_DATE,
} from '@/store/actions/survey'

export default {
  name: 'SurveyParticipant',
  mixins: [CommonMethodMixin],
  components: {
    SurveyAttachment,
    SurveyAttachmentCommon,
    SurveyParticipantFloatLeftOnly,
},
  props: {
    seq: {
      type: Number,
      required: true
    },
    participant: {
      type: Object,
      required: true
    },
  },
  computed: {
    ...mapState(SURVEY_SYDNEY, {
      hint: state => state.hint,
    }),
    ...mapGetters(SURVEY_SYDNEY, {
      attendingList: ATTENDING_LIST,
      questions: COMMON_QUESTIONS,
      infoAvailable: INFO_AVAILABLE,
      needFamilyRelationDocument: NEED_FAMILY_RELATION_DOCUMENT,
      needFamilyDocument: NEED_FAMILY_DOCUMENT,
      spouseAttendants: SPOUSE_ATTENDANTS,
      memberAttendants: MEMBER_ATTENDANTS,
      counties : GET_CODE_COUNTRY,
      today: GET_CODE_TODAY,
      passportDate: GET_CODE_PASSPORT_DATE,
    }),
    isLeft() {
      return this.seq % 2 === 0;
    },
    disabledByType() {
      return this.participant.type === 'E' || this.participant.type === 'P';
    },
    disabledByAttendance() {
      return !this.participant.attendance_yn || this.participant.attendance_yn === 'N';
    },
    isSole() {
      return this.participant.type === 'E';
    },
    existSpouse() {
      return this.spouseAttendants.length > 0;
    },
    existMember() {
      return this.memberAttendants.length > 0;
    },
    isFirstParty() {
      if(!this.existMember && this.participant.type === 'P' && this.participant.type_seq === 1) {
        return true;
      } else {
        const firstParty = this.attendingList.filter(attendant => attendant.type === 'P').sort((a, b) => a.type_seq - b.type_seq)[0];
        return firstParty ? (firstParty.type === this.participant.type && firstParty.type_seq === this.participant.type_seq) : false;
      }
    },
    hideDocument() {
      return !(this.isSole || this.isFirstParty);
    },
    ishint () {
      return !this.disabledByAttendance && this.infoAvailable && this.hint
    },
    juminHasError() { 
        const firstError = this.participant.questions['Q112_1'].hasError;
        const secondError = this.participant.questions['Q112_2'].hasError;
        const domestic = this.participant.questions['Q111'].hasError;

        if (domestic) { 
          return "내/외국인 여부를 선택해 주세요."
        } else if (firstError && this.participant.questions['Q112_1'].remarks) { 
          return this.participant.questions['Q112_1'].remarks;
        } else if (secondError && this.participant.questions['Q112_2'].remarks) { 
          return this.participant.questions['Q112_2'].remarks;
        } else if (firstError || secondError) { 
          return "숫자 13자리를 입력해주세요."
        }
    }
  },
  methods: {
    selectAttendance(e) {
      const attendance_yn = e.target.value;
      this.$store.commit(`${SURVEY_SYDNEY}/${SET_ATTENDANCE}`, { idx: this.seq, attendance_yn });
      if(attendance_yn === 'N') {
        if(!this.existMember) {
          this.$store.commit(`${SURVEY_SYDNEY}/${SET_FAMILY_ATTENDANCE_YN}`, attendance_yn);
        }
        // this.$store.dispatch(`${SURVEY_SYDNEY}/${CLEAR_RESPONSE_DATA}`, this.seq);
      }
    },
    navtiveAlert(msg){
      window.alert(msg);
    }
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/surveys/sydney/components/SurveyParticipant.vue